module.exports = __webpack_public_path__ + "media/landing_page/shopper-jobs-become-shopper-2ac93b6b.jpg";